module.exports = __webpack_public_path__ + "static/img/qrcode.58a50bea.png";